import _styled from "styled-components";
import "core-js/modules/web.dom-collections.iterator.js";
import React from "react";
import { useDraggable } from "./useDraggable";
import { jsx as _jsx } from "react/jsx-runtime";
const DragWrapper = _ref => {
  let {
    children,
    handleSelector,
    style,
    wrapperCSS
  } = _ref;
  const [ref] = useDraggable({
    handleSelector
  });
  return /*#__PURE__*/_jsx(_StyledDiv, {
    style: style,
    ref: ref,
    $_css: wrapperCSS,
    children: children
  });
};
export default DragWrapper;
var _StyledDiv = _styled("div").withConfig({
  displayName: "DragWrapper___StyledDiv",
  componentId: "sc-35ptb1-0"
})(["", ""], p => p.$_css);